module.exports = __webpack_public_path__ + "static/media/hall-P9.91af90d1.svg";